import styles from './TimeTrackingTabPanel.module.scss';

import { useMemo } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useTicketToTimeTracking } from '../../../../../../../../hooks/use-ticket-to-time-tracking';
import { EntityTableView } from '../../../../../../../file-entities-lists';
import { useFormContextPlus } from '../../../../../../form-plus/use-form-context-plus';
import { Panel } from '../../../../../components/panel/Panel';
import { useMaskContext } from '../../../../../hooks/mask-context';
import { TicketMaskFormValue } from '../../../types';

export const TimeTrackingTabPanel = () => {
  const mask = useMaskContext();
  const { watch } = useFormContextPlus<TicketMaskFormValue>();

  const ticket = watch();
  const init = useTicketToTimeTracking(ticket);
  const presetFields = useMemo(() => {
    return JSON.stringify(init);
  }, [init]);

  return (
    <Panel className={styles.maxHeight}>
      <EntityTableView
        entityType={Entities.ticketTimeTracking}
        prefilter={[
          {
            'ticket.id': { $eq: mask.id },
          },
        ]}
        tableComponentProps={{
          maskParams: {
            presetFields,
          },
        }}
      />
    </Panel>
  );
};
